import type { FC } from "react";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { selectUserBySectionUserId } from "store/selectors";
import { useObjectSelector } from "store/store-hooks";
import { PROFILE_PROPERTIES, getUserFullName } from "utils/user-utils";

export type GroupSubmittedByBannerProps = {
  sectionUserId: string | null | undefined;
};

export const GroupSubmittedByBanner: FC<GroupSubmittedByBannerProps> = ({ sectionUserId }) => {
  const submittedByUser = useObjectSelector(
    (s) => selectUserBySectionUserId(s, sectionUserId),
    PROFILE_PROPERTIES,
  );

  if (!submittedByUser) {
    return null;
  }

  const fullName = getUserFullName(submittedByUser);

  return (
    <Banner className="page-block-width" kind="info">
      {t("warning.group_submitted_by", { name: fullName })}
    </Banner>
  );
};
